import styled from 'styled-components';

import { Headline, Tile } from '../../components';

export const StyledOverviewCards = styled.div`
  display: flex;
  padding: 32px var(--side-padding) 0;
`;

export const StyledContainer = styled.div`
  display: flex;
  max-width: 645px;
  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;

export const StyledOverviewCardsContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const StyledScoreTile = styled(Tile)`
  min-height: 129px;

  &:before {
    display: none;
  }
`;

export const StyledHeadline = styled(Headline)`
  position: relative;
  z-index: 2;
  & > span:first-of-type {
    font-weight: 900;
  }
`;
